module.exports = __webpack_public_path__ + "static/media/COTS_map.c8f40397.svg";